import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import { CompanySignUpForm } from '../../components/CompanySignUpForm/CompanySignUpForm';
import { getAuthRoute } from '../../utils/getAuthRoute';

export const SignUpCompany = () => {
  return (
    <AuthLayout
      title="Trade recyclables the smart way"
      subtitle="You are only a few steps away from creating your account and getting started with Safi."
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Setup your company
      </Typography>
      <Typography>You can update your company information at any time in the future.</Typography>
      <CompanySignUpForm />
      <Link component={RouterLink} to={getAuthRoute('/sign-up/verify')}>
        Go back
      </Link>
    </AuthLayout>
  );
};
